import React, { useEffect, useState } from 'react';
import { Skeleton, Empty } from 'antd';
import api from '../../services/api';
import TeamMatchesPanel from '../../components/community/TeamMatchesPanel';
import { resolveActiveTeam } from '../../utils/activeTeam';

// Menu 'Jogos' do dono do time-comunidade. Time ativo persiste entre
// telas via localStorage (helper resolveActiveTeam).
export default function TeamOwnerMatchesPage() {
  const [team, setTeam] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/community/team-owner/my').then(r => {
      setTeam(resolveActiveTeam(r.data?.teams || []));
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40 }}><Skeleton active /></div>;
  if (!team) return <Empty description="Nenhum time encontrado" style={{ padding: 60 }} />;

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 16 }}>
      <TeamMatchesPanel teamId={team.id} teamName={team.name} />
    </div>
  );
}
